import { combineReducers } from 'redux';

import reviews from './reviews';

export const reducers = combineReducers({ reviews });
